import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LanguageContext from './contexts/LanguageContext';
import * as Sentry from '@sentry/react';
import { REACT_APP_ENV, REACT_APP_SENTRY_DSN } from 'config';

console.log('version 1');

Sentry.init({
  dsn: REACT_APP_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration()
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/ole\.com\/api/],
  enableLogs: true,
  environment: REACT_APP_ENV,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const language = 'en';

root.render(
  <React.StrictMode>
    <LanguageContext.Provider value={language}>
      <App/>
    </LanguageContext.Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
